import axios from 'axios'

var qs = require('qs');
var root = process.env.API_ROOT

export const detailTenantid = () => {
  return axios.post(root + '/set/tenant/company')
}

export const saveTenantid = (params) => {
  return axios.post(root + '/sysmanage/managingtenant/save', qs.stringify(params))
}

export const listDept= () => {
  return axios.post(root + '/set/dept/listHasStore')
}

export const saveDept= (params) => {
  return axios.post(root + '/set/dept/save', qs.stringify(params))
}

export const updateDept= (params) => {
  return axios.post(root + '/set/dept/update', qs.stringify(params))
}

export const removeDept= (params) => {
  return axios.post(root + '/set/dept/remove', qs.stringify(params))
}

export const startUse = () => {
  return axios.post(root + '/set/tenant/startUse')
}




// WEBPACK FOOTER //
// ./src/api/sysmanage/register.js